import React from "react";
import "./App.css";
import AllRoutes from "./Components/Routes/AllRoutes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
function App() {
  const handle = useFullScreenHandle();
  return (
    <FullScreen handle={handle}>
      <div
        className={`${
          handle.active ? "fullscreen-container full-screen-mode" : ""
        }`}
        style={{ overflow: handle.active ? "auto" : "" }} 
      >
        <AllRoutes onCallFullScreen={handle} />
        <ToastContainer position={"bottom-right"} />
      </div>
    </FullScreen>
  );
}

export default App;
